import { createElement, memo } from '@max/max';
import View from '@hfe/max-view';
import Text from '@hfe/max-text';
import './LoadMore.scss';
import Image from '@hfe/max-image';
import { getImage } from "../../utils/common";
function LoadMore(p) {
    const border = {
        border: `2rpx solid ${p.color}`
    };
    return <View className="loadMore-container">
      <View className="loadMore-button" onClick={p.onClick}>
        <Text className="loadMore-text" style={{
            color: p.color
        }}>查看更多</Text>
        <Image className="loadMore-arrow" source={getImage(p.icon)}/>
      </View>
    </View>;
}
export default memo(LoadMore);
